import Vue from 'vue';
import Buefy from 'buefy';

import FAQsList from './App.vue';

Vue.use(Buefy, {
    defaultIconPack: 'fas',
})

Vue.use(FAQsList)

if (document.getElementById("faqsPublicApp")){
    new Vue({
        render:h=>h(
            FAQsList, {
                props:{
                    faqsList:document.getElementById("faqsPublicApp").getAttribute("faqs-list")
                }
            }
        )
    }).$mount("#faqsPublicApp")
}